/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.Model,
    mapping:{
        pagination:require('./Pagination'),
        list:require('./List')
    },
    method:{
        init:function () {
            var pagination = this.get('pagination');
            var list = this.get('list');
            this.onChange('data',function (inEvent,inData) {
                var isInit = pagination.get('isInit') || false;
                var page = inData.page;
                var items = inData.rows || [];
                list.set('items',items);
                if(!isInit){
                    pagination.setOpts({
                        initPagination:page
                    });
                }
                this.set('dataReady','data-ready');
            },this);
            pagination.onChange('requirePage',function (inEvent,inPageNO) {
                this.set('dataReady','');
                this.set('requirePage',inPageNO);
            },this);

            this.onChange('itemType',function (inEvent,inType) {
                list.set('itemType',inType);
            },this);
            this.onChange('itemModelType',function (inEvent,inType) {
                list.set('itemModelType',inType);
            },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/pagination/PaginationList.js
// module id = 56
// module chunks = 1 3 11 12 14 16 17 24 31 33